import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Row, Col, Select } from 'antd';
import { CustomText, TableWrapper, Table, CustomLabel6 } from '@4beefopag/4bee-fopag-core/dist/atoms';
import styled from 'styled-components';

const CustomModal = styled(Modal)`
  width: 500px;
`;

const CustomTable = styled(TableWrapper)`
  & td,
  & th {
    padding: 8px 20px !important;
  }
`;

function ModaDivergenciaPlanilha({ visible, onOk, onCancel, loading, camposNaoExistentes }) {
  const { Option } = Select;

  const carregarCamposNaoExistentes = () =>
    camposNaoExistentes.split('|').map((c) => ({
      campo: c,
      valor: '1',
    }));

  const [listaCampos, setListaCampos] = useState(carregarCamposNaoExistentes());

  useEffect(() => {
    setListaCampos(carregarCamposNaoExistentes());
  }, [camposNaoExistentes]);

  return (
    <CustomModal
      visible={visible}
      title="Colunas faltando no excel"
      onOk={onOk}
      onCancel={onCancel}
      closeable={false}
      footer={[
        <Button
          key="back"
          onClick={() => {
            onCancel();
            setListaCampos([]);
          }}
          disabled={loading}
        >
          Cancelar
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={async () => {
            await onOk(listaCampos);
            setListaCampos([]);
          }}
          disabled={listaCampos.length !== camposNaoExistentes.split('|').length}
          loading={loading}
        >
          {listaCampos.length !== camposNaoExistentes.split('|').length ? (
            <CustomText color="#d9d9d9">Importar</CustomText>
          ) : (
            <CustomText color="white">Importar</CustomText>
          )}
        </Button>,
      ]}
    >
      <Row
        type="flex"
        gutter={[16, 16]}
      >
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
        >
          <span>
            Não encontramos algumas colunas no arquivo importado, o que deseja fazer com as colunas que estão faltando?
          </span>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
        >
          <CustomTable>
            <Table
              widthInput="112px"
              background="#f6f7f9"
              borderBottomTh="1px solid #e8e8e8"
              borderBottomTd="1px solid #e8e8e8"
              style={{ width: '438px' }}
            >
              <thead>
                <tr>
                  <th style={{ width: '280px' }}>
                    <CustomLabel6>Coluna do excel</CustomLabel6>
                  </th>
                  <th
                    style={{ width: '180px' }}
                    colSpan={2}
                  >
                    <CustomLabel6>Valor</CustomLabel6>
                  </th>
                </tr>
              </thead>
              <tbody>
                {listaCampos.map((campoNaoExistente) => (
                  <tr key={campoNaoExistente.campo}>
                    <td>{campoNaoExistente.campo}</td>
                    <td>
                      <Select
                        placeholder="Selecione..."
                        value={campoNaoExistente.valor}
                        onChange={(value) => {
                          const idx = listaCampos.findIndex((c) => c.campo === campoNaoExistente.campo);
                          const novosCampos = [...listaCampos];
                          novosCampos[idx].valor = value;

                          setListaCampos([...novosCampos]);
                        }}
                        style={{ minWidth: '230px' }}
                      >
                        <Option value="0">Zerar o valor</Option>
                        <Option value="1">Manter o valor do apontamento</Option>
                        {campoNaoExistente.campo === 'Produção' && <Option value="2">Cálculo automático</Option>}
                      </Select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </CustomTable>
        </Col>
      </Row>
    </CustomModal>
  );
}

ModaDivergenciaPlanilha.propTypes = {
  visible: PropTypes.bool,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  camposNaoExistentes: PropTypes.string,
};

ModaDivergenciaPlanilha.defaultProps = {
  visible: false,
  camposNaoExistentes: '',
};

export default ModaDivergenciaPlanilha;
